export default "__VITE_ASSET__Di$73KoX__"